import React, { useContext } from "react";
import {
  Divider,
  List,
  ListItem,
  ListItemText,
  ListSubheader,
  Typography,
} from "@mui/material";

import { useSearchParams } from "react-router-dom";

import { getMetadataFieldList } from "../../services/utils";
import { MetadataConfigurationContext } from "../../metadataConfigurationProvider";
import { ProgramsContext } from "../../programsProvider";
import { addNewMetadaToOrderedList } from "./displayMetadataUtils";

const DisplayMetadataList = () => {
  const allPrograms = useContext(ProgramsContext);
  const metadataConfiguration = useContext(MetadataConfigurationContext);

  const [searchParams] = useSearchParams();
  const objectType = searchParams.get("objectType");
  const programId = searchParams.get("programId");

  const program = allPrograms.find(({ id }) => id === programId);
  const metadataFieldList = getMetadataFieldList(metadataConfiguration)(
    objectType,
  )(program.configurationID);

  const metadataList = addNewMetadaToOrderedList(metadataFieldList, objectType);

  return (
    <>
      <Typography variant="h4">
        {program.name} - {objectType.toUpperCase()} Metadata Values
      </Typography>
      <List
        sx={{
          width: "100%",
          maxWidth: 600,
          bgcolor: "background.paper",
          position: "relative",
          overflow: "auto",
          maxHeight: "100%",
          "& ul": { padding: 0 },
        }}
        component="ul"
        disablePadding
        subheader={<li />}
      >
        {metadataList.map((metadata) => (
          <>
            <li key={`section-${metadata.label}`}>
              <ul>
                <ListSubheader>{`${metadata.label}`}</ListSubheader>
                {metadata.values.sort().map((value) => (
                  <ListItem sx={{ display: "list-item" }}>
                    <ListItemText key={value} primary={value} />
                  </ListItem>
                ))}
              </ul>
              <Divider component="li" />
            </li>
          </>
        ))}
      </List>
    </>
  );
};

export { DisplayMetadataList };
